import { userHasNoRoles } from './helpers'
import { middlewareContext, middlewareInstructions } from './types'
import { usePermissions } from '~/composables/permissions'
import { toast } from 'vue-sonner'
import { isSingaporeRestrictionActive } from '~/constants/restrictions'

export default function hasPermission(
  ctx: middlewareContext,
): middlewareInstructions {
  const { hasRoutePermission } = usePermissions()

  const { to } = ctx
  const routeName = to.name

  const user = useUserStore()

  if (
    userHasNoRoles() ||
    (!hasRoutePermission(routeName) &&
      routeName === 'subscription-portal-subscriptions')
  ) {
    return { to: { name: 'subscription-portal-sign-in' }, actions: 'logout' }
  }

  if (
    (routeName
      ?.toString()
      .startsWith('subscription-portal-subscriptions-new') ||
      routeName?.toString().includes('upgrade-printer-seats')) &&
    isSingaporeRestrictionActive &&
    user.partner.billingCountry === 'SG'
  ) {
    return {
      to: { name: 'subscription-portal-subscriptions' },
    }
  }

  if (hasRoutePermission(routeName)) {
    return { to: { name: '' } }
  }

  setTimeout(() => {
    toast.error('Access restricted: Insufficient authorization.')
  }, 500)

  return {
    to: { name: 'subscription-portal-subscriptions' },
  }
}
